<template>
    <div>
        <div v-if="!error && !loading" class="content">
            <template v-if="singlepage">
                <div class="page box">
                    <h3 class="title is-4">Congres</h3>
                    <div>Historique des congrès nationaux des équipes mobiles :</div>
                    <br>
                    <table class="table is-fullwidth has-background-white">
                        <tr class="has-background-grey-lighter">
                            <th>Année</th>
                            <th>Lieu</th>
                            <th>Thème</th>
                            <th colspan="2">Ressources</th>
                        </tr>
                        <tr v-for="(congre) in congres" v-bind:key="congre._id">
                            <td>{{congre.annee}}</td>
                            <td>{{congre.lieu}}</td>
                            <td>{{congre.theme}}</td>
                            <td>
                                <router-link v-if="congre.programme" class="button is-small is-info" :to="'/'+ congre.programme+''">
                                    <b-icon icon="download"></b-icon><span> Programme</span>
                                </router-link>
                            </td>
                            <td>
                                <router-link v-if="congre.moreinfos" :to="'/'+ congre.moreinfos+''">
                                    <span>🔎 Retour sur le congrès</span>
                                </router-link>
                            </td>
                        </tr>
                    </table>
                </div>
            </template>
            <template v-else>
                <table class="table is-fullwidth is-size-7-mobile has-background-light">
                    <tr class="has-background-grey-lighter">
                        <th>Année</th>
                        <th>Lieu</th>
                        <th>Thème</th>
                        <th colspan="2">Ressources</th>
                    </tr>
                    <tr v-for="(congre) in congres" v-bind:key="congre._id">
                        <td>{{congre.annee}}</td>
                        <td>{{congre.lieu}}</td>
                        <td>{{congre.theme}}</td>
                        <td>
                            <router-link v-if="congre.programme" class="button is-small is-info" :to="'/'+ congre.programme+''">
                                <b-icon icon="download"></b-icon><span> Programme</span>
                            </router-link>
                        </td>
                        <td>
                            <router-link v-if="congre.moreinfos" :to="'/'+ congre.moreinfos+''">
                                <span>🔎 Retour sur le congrès</span>
                            </router-link>
                        </td>
                    </tr>
                </table>
            </template>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data: function() {
        return {
            loading: true,
            page: null,
            error: null,
            congres: [],
        }
    },
    name: 'Congres',
    props: {
        singlepage: Boolean
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_congres
            axios({
                    method: 'get',
                    url: fetchurl
                }).then(function(response) {
                    vm.loading = false
                    vm.congres = response.data.entries
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 40px;
}
</style>